<template>
  <div class="main-container">
    <!-- 顶部导航栏 -->
    <nav class="admin-nav-bar">
      <a href="/" style="text-decoration: none;">
        <div class="logo">
          <img src="https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png" width="40" height="40" alt="小晖智能客服"/>
          <span>小晖智能客服 · 企业管理中心</span>
        </div>
       </a>
      <!-- 用户操作区 - 关键修复部分 -->
      <div class="user-actions">
        <span class="welcome-text">欢迎您使用小晖AI客服平台</span>

        <div class="user-dropdown" ref="dropdownContainer" v-click-outside="closeDropdown">
          <div class="dropdown-trigger" @click.stop="toggleDropdown">
            <div class="avatar-group">
              <img
                src='https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise/default_avatar.png'
                class="user-avatar"
                alt="用户头像"
              >
              <span class="username">{{ userInfo.username }}</span>
              <i class="el-icon-arrow-down" :class="{ rotated: isDropdownOpen }"></i>
            </div>
          </div>

          <!-- 下拉菜单 -->
          <transition name="el-fade-in">
            <div
              v-show="isDropdownOpen"
              class="dropdown-menu"
            >
              <div class="menu-item" @click="show_agreement">
                <svg style="margin-right: 8px;" t="1763807678190" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5574" width="16" height="16"><path d="M744.96 1000.96L179.2 998.4c-69.12 0-128-56.32-128-128V153.6c0-69.12 56.32-128 128-128h550.4c69.12 0 128 56.32 128 128v240.64c0 23.04-17.92 43.52-43.52 43.52-23.04 0-43.52-17.92-43.52-43.52V153.6c0-23.04-17.92-43.52-43.52-43.52H179.2c-23.04 0-43.52 17.92-43.52 43.52v719.36c0 23.04 17.92 43.52 43.52 43.52h565.76c46.08 0 69.12 15.36 69.12 43.52 0 25.6-23.04 40.96-69.12 40.96z m-481.28-235.52c-2.56 0-7.68 0-10.24-2.56-10.24-5.12-12.8-17.92-7.68-28.16 89.6-161.28 125.44-156.16 138.24-153.6 7.68 2.56 23.04 7.68 28.16 33.28 5.12 20.48 5.12 43.52 7.68 61.44v12.8l15.36-17.92c30.72-35.84 51.2-56.32 74.24-51.2 20.48 5.12 28.16 28.16 28.16 35.84 2.56 12.8 2.56 23.04 2.56 33.28 2.56-2.56 7.68-2.56 10.24-5.12 10.24-5.12 23.04 0 28.16 10.24 5.12 10.24 0 23.04-10.24 28.16-33.28 15.36-51.2 23.04-66.56 10.24-12.8-10.24-10.24-25.6-7.68-35.84 2.56-10.24 5.12-20.48 2.56-30.72-7.68 7.68-20.48 20.48-30.72 33.28l-17.92 17.92c-10.24 10.24-28.16 30.72-48.64 23.04-20.48-7.68-23.04-30.72-23.04-61.44 0-15.36-2.56-30.72-5.12-48.64-20.48 17.92-56.32 69.12-89.6 128-5.12 5.12-10.24 7.68-17.92 7.68z m-43.52-486.4h465.92v43.52H220.16v-43.52z m0 84.48h465.92v43.52H220.16v-43.52z m0 84.48h381.44v43.52H220.16v-43.52z m744.96 0l20.48 15.36c23.04 15.36 28.16 48.64 10.24 71.68l-199.68 276.48c-7.68 10.24-15.36 15.36-28.16 17.92l-81.92 23.04-2.56-84.48c0-10.24 2.56-23.04 10.24-30.72L893.44 460.8c17.92-23.04 48.64-28.16 71.68-12.8z" fill="#1296db" p-id="5575"></path></svg>
                <span>协议与隐私</span>
              </div>            
              <div v-if="loginType==='password'" class="menu-item" @click="ChangePassword">
                <i class="el-icon-lock"></i>
                <span>修改密码</span>
              </div>
              <div v-if="loginType==='sms'" class="menu-item" @click="passwordSetting_sms">
                <i class="el-icon-lock"></i>
                <span>设置密码</span>
              </div>
              <div class="menu-divider"></div>
              <div class="menu-item logout" @click="logoutConfirm">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </nav>

    <!-- 主内容区 -->
    <div class="admin-main">
      <!-- 内容区 -->
      <div class="content">
        <!-- 流程图 -->
        <div class="flowchart-container">
          <div class="flowchart-title">拥有专属AI客服的主流程</div>
          <div class="flowchart">
            <div class="flow-step">
              <div :class="step1_class">1</div>
              <div class="step-text">实名认证</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div :class="step2_class">2</div>
              <div class="step-text">等待审核</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div :class="step3_class">3</div>
              <div class="step-text">选择套餐<a style="font-size: 8pt;">(试用版无需)</a></div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div :class="step4_class">4</div>
              <div class="step-text">支付<a style="font-size: 8pt;">(试用版无需)</a></div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon-with-border">5</div>
              <div class="step-text">开通会员</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">6</div>
              <div class="step-text">创建团队</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">7</div>
              <div class="step-text">构建知识库</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">8</div>
              <div class="step-text">上传文档</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">9</div>
              <div class="step-text">测试AI客服</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">10</div>
              <div class="step-text">上线客服中心</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">11</div>
              <div class="step-text">部署客服席位</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">12</div>
              <div class="step-text">查看统计数据</div>
              <div class="step-arrow">→</div>
            </div>
            <div class="flow-step">
              <div class="step-icon">13</div>
              <div class="step-text">优化AI客服</div>
            </div>
          </div>
        </div>

             <!-- 实名认证表格 -->
     <div class="plans-container">
          <div class="section-title">① 实名认证
            <svg v-if="tenantInfo===null || tenantInfo.status!='APPROVED'" style="margin-left: 10px;" t="1761477356101" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7606" width="24" height="24"><path d="M515.072 97.024l5.76 1.088 373.184 109.056c13.312 3.84 22.4 16 22.4 29.824v223.552c0 244.352-154.752 446.72-394.56 526.656a31.104 31.104 0 0 1-19.648 0c-239.936-79.936-394.688-282.368-394.688-526.72V236.992c0-13.824 9.152-25.984 22.4-29.824l373.504-109.056a31.104 31.104 0 0 1 17.472 0z m-3.008 63.36L169.728 260.288v200.192c0 210.944 129.728 386.304 334.848 461.632l7.424 2.56 7.488-2.56c199.36-73.28 327.424-240.96 334.4-444.032l0.32-17.536V260.288L512 160.384zM512 283.584a134.848 134.848 0 0 1 94.08 231.296 196.928 196.928 0 0 1 102.912 173.12 31.104 31.104 0 0 1-62.208 0 134.848 134.848 0 1 0-269.632 0 31.104 31.104 0 0 1-62.208 0c0-74.752 41.6-139.776 102.912-173.184A134.848 134.848 0 0 1 512 283.52z m0 62.208A72.576 72.576 0 1 0 512 490.88a72.576 72.576 0 0 0 0-145.152z" fill="#8a8a8a" p-id="7607"></path></svg>
            <svg v-else style="margin-left: 10px;" t="1761477767334" class="icon" viewBox="0 0 1169 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1647" width="24" height="24"><path d="M72.227662 0h996.553234c17.168557 1.082587 33.980498 7.794627 46.780497 19.359204 16.162388 14.239204 25.7401 35.547065 25.6 57.084179 0.012736 167.915622 0.025473 335.831244 0 503.734129-25.803781-31.751642-58.192239-58.141294-94.605373-76.812736-37.686766-19.435622-79.627463-30.47801-121.988458-32.261094-49.620697-2.228856-99.776318 8.227662-144.238806 30.401592-37.393831 18.531343-70.737512 45.11204-97.216318 77.360398-29.497313 35.827264-50.384876 78.697711-60.255523 124.039005-14.277413 64.751443-6.075224 134.240796 23.294727 193.719403-189.911244 0.025473-379.809751 0.012736-569.708259 0.012736-21.549851 0.127363-42.883184-9.450348-57.096915-25.625473C7.8201 858.249552 1.146269 841.501294 0 824.409154V72.40597C1.120796 54.345871 8.54607 36.680597 21.167761 23.638607 34.38806 9.628657 53.046766 1.235423 72.227662 0m240.487164 132.190249c-28.64398 3.362388-56.07801 16.162388-77.054726 35.954627-22.530547 20.96398-37.623085 49.735323-41.927961 80.213333-4.444975 30.274229 1.630249 61.974925 17.104876 88.39005 16.862886 29.153433 44.857313 51.671244 77.029254 61.707462 31.369552 9.99801 66.330746 8.138507 96.41393-5.22189 30.121393-13.169353 55.071841-37.635821 68.890746-67.451542 14.442985-30.681791 16.71005-66.827463 6.393632-99.126767-9.488557-30.363383-30.108657-56.995025-56.918607-74.061691-26.415124-16.926567-58.790846-24.275423-89.931144-20.403582m333.475025 31.471443c-6.457313 2.088756-11.984876 6.852139-14.965174 12.940099-3.960995 7.845572-3.413333 17.741692 1.426467 25.077811 4.63602 7.374328 13.271244 11.895721 21.97015 11.679204 109.978109 0.025473 219.968955 0.025473 329.947064 0.012736 8.698905 0.216517 17.346866-4.304876 22.021095-11.666467 5.196418-7.883781 5.412935-18.684179 0.522189-26.771742-4.534129-7.832836-13.475025-12.774527-22.517811-12.507064-107.851144 0.012736-215.689552 0-323.52796 0-4.9799 0.038209-10.0999-0.38209-14.87602 1.235423m0.063681 110.793233c-6.775721 2.152438-12.545274 7.29791-15.436418 13.80617-3.642587 7.947463-2.763781 17.754428 2.279801 24.899502 4.725174 6.966766 13.080199 11.195224 21.498906 11.004179 110.436617 0 220.873234 0.076418 331.309851-0.038209 14.035423 0.012736 26.134925-13.334925 24.670248-27.319403-0.598607-9.832438-7.501692-18.837015-16.773731-22.084776-5.005373-1.897711-10.443781-1.464677-15.678408-1.490149H661.027662c-4.941692 0.038209-10.010746-0.38209-14.77413 1.222686M214.199403 476.605771c-30.516219 23.460299-53.925572 55.976119-66.636418 92.3001-12.507065 35.648955-14.557612 74.851343-6.024279 111.63383 130.101493 0.025473 260.190249-0.025473 390.291742 0.025473 9.552239-40.794428 5.896915-84.581891-10.418309-123.172935-16.95204-40.450547-47.646567-74.940498-85.804577-96.515821-32.286567-18.505871-69.858706-27.53592-107.010547-25.931144-41.252935 1.464677-81.843582 16.315224-114.397612 41.660497z" p-id="1648" fill="#1296db"></path><path d="M882.028259 511.694328c50.066468-5.84597 101.788657 3.247761 146.658706 26.300498 39.75005 20.3399 74.061692 51.2 98.413533 88.619303 21.231443 32.464876 34.922985 69.795025 39.60995 108.296916 5.514826 44.296915-0.611343 90.045771-17.970946 131.196816-21.129552 50.512239-58.943682 93.85393-106.144477 121.63184-32.65592 19.410149-69.74408 31.433234-107.609154 34.668259-44.742687 4.126567-90.542488-3.782687-131.273234-22.772537-37.228259-17.346866-70.202587-43.711045-95.254926-76.277811-27.29393-35.317811-45.137512-77.882587-50.983482-122.141294-6.355423-47.022488 0.458507-95.789851 19.906866-139.093333 18.505871-41.58408 48.359801-77.971741 85.384278-104.399602 35.012139-25.090547 76.456119-41.125572 119.262886-46.029055m144.633632 157.051543c-5.056318 1.69393-8.877214 5.553035-12.481592 9.297512-41.813333 41.813333-83.61393 83.626667-125.44 125.414527-26.020299-25.994826-52.027861-52.015124-78.035423-78.022686-3.222289-3.209552-6.317214-6.724776-10.469254-8.737115-7.705473-3.973731-17.512438-3.324179-24.606567 1.642986-5.553035 4.024677-10.341891 9.666866-11.704677 16.557213-1.872239 8.100299 0.904279 16.977512 6.915821 22.708856 33.52199 33.509254 67.018507 67.056716 100.578706 100.540498 6.406368 6.457313 16.56995 8.660697 25.103284 5.553035 6.266269-2.037811 10.405572-7.412537 15.385473-11.386269 47.009751-46.882388 93.904876-93.904876 140.889154-140.812736 3.515224-3.375124 6.32995-7.578109 7.463483-12.366966 5.234627-18.467662-15.652935-37.686766-33.598408-30.388855z" p-id="1649" fill="#1296db"></path></svg>
              <a class="status-text" v-if="tenantInfo===null">未提交认证申请</a>
            <a class="status-text" v-if="tenantInfo!==null && tenantInfo.status=='PENDING'">已提交认证申请，待审核</a>
            <el-button  v-if="tenantInfo===null" type="text" style="margin-left: 10px;border: 1px solid #409EFF; font-weight: bold; border-radius: 2px; padding: 5px;" @click="HandleAuthentication">去认证（认证后，您将领取一年的免费试用）</el-button></div>
          <p  v-if="tenantInfo===null"  class="section-description">AI客服是平台租户的代言人、代表着租户的公共形象。为了避免冒用他人资质、侵犯他人合法利益的情况。您需要提供您的资质证明，通过平台的审核后才能拥有自己的专属AI客服。不同类型的用户需要提供的资质证明，具体如下：</p>

          <div class="plans-table-container">
            <table  v-if="tenantInfo===null"  class="plans-table">

              <thead>
                <tr>
                  <th class="feature-col">用户类型</th>
                  <th class="plan-col">描述</th>
                  <th class="plan-col">资质要求</th>
                  <th class="plan-col">核心凭证</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="feature-name">企业</td>
                  <td class="plan-feature">有限公司、股份有限公司等</td>
                  <td class="plan-feature">营业执照认证</td>
                  <td class="plan-feature">营业执照照片/扫描件、企业名称、统一社会信用代码</td>
                </tr>
                <tr>
                  <td class="feature-name">个体工商户</td>
                  <td class="plan-feature">依法登记从事经营活动的个人或家庭</td>
                  <td class="plan-feature">营业执照认证</td>
                  <td class="plan-feature">个体工商户营业执照</td>
                </tr>
                <tr>
                  <td class="feature-name">政府与事业单位</td>
                  <td class="plan-feature">各级政府机关、学校、医院、科研单位等</td>
                  <td class="plan-feature">登记证书认证</td>
                  <td class="plan-feature">单位盖章的申请公函、经办人身份信息</td>
                </tr>
                <tr>
                  <td class="feature-name">社会组织</td>
                  <td class="plan-feature">社会团体、基金会、民办非企业单位等</td>
                  <td class="plan-feature">登记证书认证</td>
                  <td class="plan-feature">社会组织登记证书/慈善组织公开募捐资格证书</td>
                </tr>
                <tr>
                  <td class="feature-name">个人开发者/创作者</td>
                  <td class="plan-feature">无营业执照的独立开发者、博主、创作者</td>
                  <td class="plan-feature">个人实名认证</td>
                  <td class="plan-feature">个人身份证件、辅助证明材料（如软件著作权、应用商店后台截图）</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
     <!-- 套餐表格 -->
     <div class="plans-container">
          <div class="section-title">套餐选择</div>
          <p class="section-description">小晖AI客服平台致力于为国内中小企业、小微实体提供低成本、低技术门槛的一站式AI客服解决方案，助力企业轻松实现客户服务的智能化升级。</p>

          <div class="plans-table-container">
            <table class="plans-table">
              <thead>
                <tr>
                  <th class="feature-col">项目</th>
                  <th v-if="version_settings && version_settings.length>0" class="plan-col">{{version_settings[0].versionName}}</th>
                  <th v-if="version_settings && version_settings.length>1" class="plan-col">{{version_settings[1].versionName}}</th>
                  <th v-if="version_settings && version_settings.length>2" class="plan-col">{{version_settings[2].versionName}}</th>
                  <th v-if="version_settings && version_settings.length>3" class="plan-col">{{version_settings[3].versionName}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td  class="feature-name">目标客户</td>
                  <td class="plan-feature">新用户</td>
                  <td class="plan-feature">个体经营者、个人开发者</td>
                  <td class="plan-feature">中小团队</td>
                  <td class="plan-feature">有一定规模的企业</td>
                </tr>
                <tr>
                  <td  class="feature-name">核心价值</td>
                  <td class="plan-feature">体验功能、感知额度</td>
                  <td class="plan-feature">低成本获得 AI 客服基础能力</td>
                  <td class="plan-feature">多人协作的效率与一致性</td>
                  <td class="plan-feature">治理、合规与风险控制</td>
                </tr>                
                <tr class="price-row">
                  <td class="feature-name">月费</td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">¥{{version_settings[0].monthlyPrice}}</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">¥{{version_settings[1].monthlyPrice}}</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">¥{{version_settings[2].monthlyPrice}}</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">¥{{version_settings[3].monthlyPrice}}</td>
                </tr>
                <tr>
                  <td  class="feature-name">月度对话量<a title="套餐中包含的AI客服对话数量，AI客服每回复一次客户的提问，就会消耗1次" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].monthlyConversationCount}}次</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].monthlyConversationCount}}次</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].monthlyConversationCount}}次</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].monthlyConversationCount}}次</td>
                </tr>
                <tr>
                  <td class="feature-name">最多知识库/AI客服中心数量<a title="知识库是AI知识库（AI knowledge base）的简称。它是一个集中式的数字存储库，旨在使用AI技术存储和组织信息，并提供对信息的访问。与传统的知识库不同，AI知识库是动态和交互式的。它使用机器学习和NLP技术使其能够从与用户的交互和它接收到的数据中学习、并不断更新。知识库就好像是AI模型（大语言模型）的图书馆，它是大语言模型获取外界信息的重要途径，大语言模型也会使用自己学习到的知识更新知识库的内容，因此，这是一个互动的过程。将使用知识库的应用被称称为代理（agent），比如客服机器人就是经典的知识库代理。您的AI客服之所以可以为您代言，知识库功不可没。 当您向知识库中上传了必要的文档后，就可以把知识库部署上线了。部署上线后的知识库就是AI客服中心。AI客服中心的本质还是知识库，但是知识库只供用户内部管理、配置和测试使用，您的客户不能直接访问这个知识库。我们将部署上线前的知识库成为主知识库、而AI客服中心会使用主知识库的 一个副本，为您的最终客户提供客服服务。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].maxKbworkspaceCount}}个</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].maxKbworkspaceCount}}个</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].maxKbworkspaceCount}}个</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].maxKbworkspaceCount}}个</td>
                </tr>
                <tr>
                  <td class="feature-name">最多AI客服席位数量<a title="一个AI客服中心可以包含多个AI客服席位。AI客服席位就是一个个嵌入网页中的AI客服图标，最终客户点击AI客服图标就可以打开对话窗口与AI客服对话了。一个AI客服席位就是一个网页中的一个AI客服图标吗？还不是这样的。一个AI客服席位需要绑定到一个域名，它只能部署在这个域名下。比如，您的官网域名是www.your-company.com，您的移动端网站的域名是m. your-company.com，这就是2个域名，对应2个AI客服席位。但是，一个域名下的网站又包含很多网页。部署AI客服中心就是将 AI客服中心页面中提供的一小段代码嵌入到您的网页中。因此一个AI客服席位可以包含一个域名下的多个网页中的AI客服图标。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].maxAicsSeatCount}}个</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].maxAicsSeatCount}}个</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].maxAicsSeatCount}}个</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].maxAicsSeatCount}}个</td>
                </tr>
                <tr>
                  <td class="feature-name">知识库额度<a title="知识库额度是衡量您在 AI 客服中心可添加知识内容总量的计量单位。不同套餐包含不同的知识库额度，额度消耗规则为：一个问答对消耗1 点知识库额度，对于图文文档，每500 个字符（1个汉字相当于2个字符） = 1 点（不足 500 字按 1 点计），每 10 张图 = 1 点（不足 10 张按 1 点计）" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].kb_score}}点</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].kb_score}}点</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].kb_score}}点</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].kb_score}}点</td>
                </tr>
                <tr>
                  <td class="feature-name">图片库容量<a title="图片库是图文文档中图片的来源。如果您希望您的AI客服具备图文并茂回复的能力，就需要将图片上传至图片库，并将其添加到图文文档中。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].maxImageSpace}}MB</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].maxImageSpace}}MB</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].maxImageSpace}}MB</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].maxImageSpace}}MB</td>
                </tr>    
                <tr>
                  <td class="feature-name">图片识别<a title="对于拥有图片识别权限的租户，最终用户在与您的AI客服进行沟通时，可以上传图片，您的AI客服，可以充分理解图片中包含的信息，并基于此与最终用户进行进一步的沟通。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].imageRecognition?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].imageRecognition?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].imageRecognition?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].imageRecognition?'✓':'✗'}}</td>
                </tr>
                <tr>
                  <td class="feature-name">月图片识别数量上限<a title="对于拥有图片识别权限的租户，该指标定义您的AI客服在与最终用户进行沟通时，每月可以识别图片的最大数量。如果当前月识别图片的数量超过该指标，最终用户将不能上传图片给AI客服。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].monthlyImageRecognitionCount}}个</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].monthlyImageRecognitionCount}}个</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].monthlyImageRecognitionCount}}个</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].monthlyImageRecognitionCount}}个</td>
                </tr>
                <tr>
                  <td class="feature-name">AI客服图文并茂回复<a title="对于拥有图片识别权限的租户，您的AI客服在与最终用户进行沟通时，可以使用图片库中的图片回复最终用户。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].imageEditor?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].imageEditor?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].imageEditor?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].imageEditor?'✓':'✗'}}</td>
                </tr>     
                <tr>
                  <td class="feature-name">知识库目录<a title="对于拥有知识库目录权限的租户可以在知识库中的创建目录，以分类管理知识库文章。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].kbworkspaceFolder?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].kbworkspaceFolder?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].kbworkspaceFolder?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].kbworkspaceFolder?'✓':'✗'}}</td>
                </tr>           
                <tr>
                  <td class="feature-name">知识审核流程<a title="该权限用于定义租户编辑、发布知识库文档的工作是由系统管理员独立完成，还是由多个角色组成的团队配合完成。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">{{version_settings[0].verify_flow?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">{{version_settings[1].verify_flow?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">{{version_settings[2].verify_flow?'✓':'✗'}}</td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">{{version_settings[3].verify_flow?'✓':'✗'}}</td>
                </tr>  

                <tr>
                  <td class="feature-name">团队管理角色<a title="【企业管理员】负责本企业（实体）的整体规划、权限分配、人员管理、知识库配置和内容审核发布。注册平台用户时，提交的联系人就是企业管理员用户，联系人手机号就是管理员用户的用户名。企业管理员可以为员工用户分配不同的角色，每个角色都有自己的职责：
     【知识库管理员】：企业管理员可以执行管理知识库的创建、配置、上传文档、发布AI客服中心和部署AI客服席位等所有功能，也可以创建团队分担自己的工作。企业管理员可以为员工用户分配知识库，由员工用户负责管理和维护。分配了知识库的员工用户就是知识库管理员。
【内容编辑】： 负责知识库内容的撰写、编辑、分类、等日常运营工作。内容编辑可以编辑问答对文档，也可以通过平台提供的图文编辑器编写图文文档。
【内容审阅者】：对内容编辑提交的知识库文档进行审阅，对内容的准确性和实用性负责。通过审核的文档可以发布至知识库。
【企业管理者】：可以为AI客服运营经理和企业领导分配管理者角色，管理者角色可以查看所有用户的操作日志、以及AI客服自动解决率、未命中率、用户反馈等统计报表和与统计图表。管理者角色可以为内容编辑分配任务，从而驱动优化知识库的工作流。" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">
                    <a v-if="version_settings[0].employeesManagement===0">只有系统管理员</a>
                    <a v-if="version_settings[0].employeesManagement===1">系统管理员+知识库管理员</a>
                    <a v-if="version_settings[0].employeesManagement===2">系统管理员+知识库管理员+企业管理者</a>                    
                    <a v-if="version_settings[0].employeesManagement===3">系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</a> 

                  </td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">
                           <a v-if="version_settings[1].employeesManagement===0">只有系统管理员</a>
                          <a v-if="version_settings[1].employeesManagement===1">系统管理员+知识库管理员</a>
                          <a v-if="version_settings[1].employeesManagement===2">系统管理员+知识库管理员+企业管理者</a>                    
                          <a v-if="version_settings[1].employeesManagement===3">系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</a> 
                  </td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">
                      <a v-if="version_settings[2].employeesManagement===0">只有系统管理员</a>
                      <a v-if="version_settings[2].employeesManagement===1">系统管理员+知识库管理员</a>
                      <a v-if="version_settings[2].employeesManagement===2">系统管理员+知识库管理员+企业管理者</a>                    
                      <a v-if="version_settings[2].employeesManagement===3">系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</a> 
                  </td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">
                      <a v-if="version_settings[3].employeesManagement===0">只有系统管理员</a>
                      <a v-if="version_settings[3].employeesManagement===1">系统管理员+知识库管理员</a>
                      <a v-if="version_settings[3].employeesManagement===2">系统管理员+知识库管理员+企业管理者</a>                    
                      <a v-if="version_settings[3].employeesManagement===3">系统管理员+知识库管理员+内容编辑+内容审阅者+企业管理者</a> 
                  </td>                  
                </tr>                

                <tr>
                  <td class="feature-name">知识库部署环境<a title="知识库的部署配置会直接影响AI客服的响应速度" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">
                    <a>低配共享资源池</a>
                  </td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">
                    <a>中配共享资源池</a>
 
                  </td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">
                    <a>zibei高配共享资源池</a>                    
                   
                  </td>
                  <td v-if="version_settings && version_settings.length>3" class="plan-feature">
                    <a>高配共享资源池 或 自备专有服务器</a> 
                  </td>                  
                </tr> 
                <tr>
                  <td class="feature-name">AI 分析对话数（情感分析+意图分析）<a title="情感分析+意图分析的结果会体现在统计报表中。租户可以据此完善知识库内容，优化AI客服的表现" style="margin-left: 10px; width:24px;cursor: pointer;"><svg t="1792234811368" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5642" width="24" height="24"><path d="M473.6 460.8l-81.066667 25.6c-4.266667-12.8-8.533333-25.6-8.533333-38.4C384 388.266667 430.933333 341.333333 490.666667 341.333333h42.666666c59.733333 0 106.666667 46.933333 106.666667 106.666667 0 51.2-38.4 93.866667-85.333333 102.4v4.266667h-85.333334v-85.333334h64c12.8 0 21.333333-8.533333 21.333334-21.333333s-8.533333-21.333333-21.333334-21.333333h-42.666666c-12.8 0-21.333333 8.533333-21.333334 21.333333 0 4.266667 0 8.533333 4.266667 12.8zM512 853.333333c-187.733333 0-341.333333-153.6-341.333333-341.333333s153.6-341.333333 341.333333-341.333333 341.333333 153.6 341.333333 341.333333-153.6 341.333333-341.333333 341.333333z m0-85.333333c140.8 0 256-115.2 256-256s-115.2-256-256-256-256 115.2-256 256 115.2 256 256 256z m-42.666667-170.666667h85.333334v85.333334h-85.333334v-85.333334z" fill="#1296db" p-id="5643"></path></svg></a></td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">
                   <a v-if="version_settings[0].ai_analysis_count_monthly===0">所有对话</a>
                    <a v-else>前{{ version_settings[0].ai_analysis_count_monthly }}条/月</a>                
                  </td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">
                   <a v-if="version_settings[1].ai_analysis_count_monthly===0">所有对话</a>
                    <a v-else>前{{ version_settings[1].ai_analysis_count_monthly }}条/月</a>                    
                  </td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">
                   <a v-if="version_settings[2].ai_analysis_count_monthly===0">所有对话</a>
                    <a v-else>前{{ version_settings[2].ai_analysis_count_monthly }}条/月</a>                   
                  </td>
                                    <td v-if="version_settings && version_settings.length>3" class="plan-feature">
                   <a v-if="version_settings[3].ai_analysis_count_monthly===0">所有对话</a>
                    <a v-else>前{{ version_settings[3].ai_analysis_count_monthly }}条/月</a>                    
                  </td>
                </tr>            
                <tr>
                  <td class="feature-name">可感知服务水平</td>
                  <td v-if="version_settings && version_settings.length>0" class="plan-feature">
                     <a>标准响应</a>                   
                  </td>
                  <td v-if="version_settings && version_settings.length>1" class="plan-feature">
                    <a>标准响应</a>                           
                  </td>
                  <td v-if="version_settings && version_settings.length>2" class="plan-feature">
                    优先响应(95%的请求响应时间小于2s)
                  </td>
                                    <td v-if="version_settings && version_settings.length>3" class="plan-feature">
                    <a>专有资源  + 升级窗口可控 + 数据物理隔离</a>                    
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 加载状态 -->
        <div v-if="!isDataLoaded" class="loading-state">
          <el-skeleton :rows="1" animated />
        </div>
      </div>
    </div>


      <!-- 实名认证对话框 -->
      <el-dialog title="实名认证" :visible.sync="open_authentication" width="1024px" append-to-body class="employee-dialog">
        <el-form ref="authenticationForm" :model="authenticationForm" :rules="rules" label-width="130px">
          <el-row :gutter="10" class="mb8">
            <el-col :span="12">
              <el-form-item label="实体类型" prop="orgType">
                  <el-select 
                    v-model="authenticationForm.orgType"
                    placeholder="请选择实体类型"
                    style="width: 100%"
                    :popper-append-to-body="false"
                    @change="(val) => HandleOrgTypeChange(val)"
                    popper-class="custom-select-popper"
                  >
                    <el-option label="企业" :value="1"/>
                    <el-option label="个体工商户" :value="2" />
                    <el-option label="政府与事业单位" :value="3" />
                    <el-option label="社会组织" :value="4" />
                    <el-option label="个人开发者/创作者" :value="5" />
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="labelOrgName" prop="companyName">
                <el-input v-model="authenticationForm.companyName" placeholder="请输入企业名称" />
              </el-form-item>              
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mb8">
            <el-col :span="12">
              <el-form-item :label="labelOrgCode" prop="socialCreditCode">
                <el-input v-model="authenticationForm.socialCreditCode" placeholder="请输入社会信用代码" />
              </el-form-item>
            </el-col>            
            <el-col :span="12">
              <el-form-item label="联系人姓名" prop="contactPerson">
                <el-input v-model="authenticationForm.contactPerson" placeholder="联系人将作为管理员" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mb8">
            <el-col :span="12">
              <el-form-item label="联系人手机号" prop="contactPhone">
                <el-input v-model="authenticationForm.contactPhone" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
                  <label for="sms-code" style="display: block; float: left;font-weight: bold;margin: 8px 10px 0 10px;"><span class="required-asterisk" >*</span>短信验证码</label>
                  <div class="sms-group">
                    <el-input
                      id="sms-code"
                      v-model="authenticationForm.code"
                      type="text"
                      required
                      placeholder="6位验证码"
                      style="display: block; width: 150px;float: left;"
                      maxlength="6"/>
                    <button
                      type="button"
                      class="sms-btn"
                      :disabled="isCountingDown || !isPhoneValid"
                      @click="sendSMSCode_authentication">

                      <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
                      <span v-else>
                        <i class="el-icon-loading"></i> 发送中...
                      </span>
                                </button>
                              </div>
                        <p v-if="smsError" class="error-message">{{ smsError }}</p>                         
                    </el-col>     
          </el-row>
          <el-row :gutter="10" class="mb8">
            <el-col :span="12">
            <!-- Business License Upload -->
              <div class="form-group">
                  <label><span class="required-asterisk">*</span><b>{{ labelOrgPic }}</b></label>
                  <div class="upload-container">
                    <input
                      type="file"
                      id="businessLicense"
                      ref="licenceFile"
                      accept="image/*,.pdf"
                      @change="handleFileUpload"
                      class="file-input"
                      style="display: none"/>
                    
                    <!-- 上传区域 -->
                    <div 
                      v-if="!authenticationForm.licenceFile" 
                      class="upload-area"
                      @click="triggerFileInput">
                      <div class="upload-placeholder">
                        <span class="plus-icon">+</span>
                        <span class="upload-text">点击上传营业执照</span>
                      </div>
                    </div>
                    
                    <!-- 预览区域 -->
                    <div v-else class="preview-area">
                      <template v-if="isImageFile(authenticationForm.licenceFile)">
                        <img :src="previewImage" class="thumbnail" alt="营业执照预览">
                      </template>
                      <template v-else>
                        <span class="file-icon">📄</span>
                        <span class="file-name">{{ authenticationForm.licenceFile.name }}</span>
                      </template>
                      <button 
                        type="button" 
                        class="remove-btn" 
                        @click="removeFile">
                        ×
                      </button>                  
                    </div>
                  </div>
                </div>  
                    <p class="form-note">请上传清晰的营业执照图片（支持JPG/PNG/PDF）</p>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mb8">
            <el-col :span="24">
              <el-form-item label="AI客服应用场景" prop="aicsUsage">
                  <el-input type="textarea" :row="4"
                    v-model="authenticationForm.aicsUsage"
                    placeholder="请详细填写您使用AI客服的应用场景，这对于快速通过审核很有帮助。我们可以据此为您提供更好的服务"   
                    :maxlength="1000"
                    show-word-limit
                    :popper-append-to-body="false"                
                    class="custom-textarea"
                  />
              </el-form-item>
            </el-col>

          </el-row>    
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAuthenticationForm">确 定</el-button>
          <el-button type="plain" @click="cancelauthentication">取 消</el-button>
        </div>
      </el-dialog>
        <!-- 设置密码对话框 -->
        <el-dialog
      title="设置密码"
      :visible.sync="dialogPasswordSettings_smsVisible"
      width="400px"
      @closed="handlePasswordSettings_smsDialogClose">
      <el-form ref="passwordSettings_smsForm" :model="passwordSettings_smsForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="passwordSettings_smsForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--短信验证码 -->
          <div class="form-group">
            <label for="sms-code"><span class="required-asterisk">*</span>验证码</label>
            <div class="sms-group">
              <input
                id="sms-code"
                v-model="passwordSettings_smsForm.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">
              <button
                type="button"
                class="sms-btn"
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode_passwordSettings(userInfo.username)">

                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
    <span v-else>
      <i class="el-icon-loading"></i> 发送中...
    </span>
              </button>
            </div>
            <p v-if="smsError" class="error-message">{{ smsError }}</p>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>密码</label>
            <input v-model="passwordSettings_smsForm.password" id="password" type="password"/>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePasswordSettings_smsSubmit">
          <span v-if="!loading_passwordSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>

        <el-button @click="handlePasswordSettings_smsDialogClose">取消</el-button>        
      </span>

    </el-dialog>
    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogChangePasswordVisible"
      width="400px"
      @closed="handleChangePasswordDialogClose">
      <el-form ref="changePasswordForm" :model="changePasswordForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="changePasswordForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--原密码 -->
          <div class="form-group">
            <label for="old-password"><span class="required-asterisk">*</span>原密码</label>
              <input
                id="old-password"
                v-model="changePasswordForm.oldPassword"
                type="password"
                required
                placeholder="请输入原密码">
            </div>
          <div class="form-group">
          <label for="new-password"><span class="required-asterisk">*</span>新密码</label>
            <input v-model="changePasswordForm.newPassword" id="new-password" type="password"/>
          </div>
          <div class="form-group">
          <label for="confirm-password"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChangePasswordDialogClose">取消</el-button>
        <el-button type="primary" @click="handleChangePasswordSubmit">
          <span v-if="!loading_changepassword_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
  </el-button>
      </span>

    </el-dialog>    
    <!-- 退出确认对话框 -->
    <el-dialog
      title="确认退出"
      :visible.sync="dialogLogoutVisible"
      width="30%"
      @closed="handleLogoutDialogClose">
      <p>确定要退出登录吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLogoutVisible = false">取消</el-button>
        <el-button type="primary" @click="logout">确定</el-button>
      </span>
    </el-dialog>
    <!-- 退出确认对话框 -->
    <el-dialog
      title="确认退出"
      :visible.sync="dialogLogoutVisible"
      width="30%"
      @closed="handleLogoutDialogClose">
      <p>确定要退出登录吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLogoutVisible = false">取消</el-button>
        <el-button type="primary" @click="logout">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 协议与隐私 -->
    <el-dialog
      title="协议与隐私"
      :visible.sync="dialogAgreementVisible"
      width="80%"
    >
    <AgreementView :userInfo="userInfo"  />
    </el-dialog>    
    </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { set_password_sms, change_password} from '@/api/auth/user'
import { send_sms_code } from '@/api/common'
import { postAuthentication } from '@/api/auth/authentication'
import AgreementView from '@/components/Agreement.vue'
import { load_version_settings } from '@/api/tenant/plan'

export default {
  name: 'AdminMain',
  components:{
     AgreementView
  },
    directives: {
      'click-outside': {
        bind(el, binding) {
          el.clickOutsideEvent = function(event) {
            // 检查点击是否在元素外部
            if (!(el === event.target || el.contains(event.target))) {
              // 调用指令绑定的方法
              binding.value(event);
            }
          };
          // 添加点击事件监听
          document.addEventListener('click', el.clickOutsideEvent);
        },
        unbind(el) {
          // 移除事件监听
          document.removeEventListener('click', el.clickOutsideEvent);
        }
      }
    },
    data() {  
      return {
        version_settings: [],
    
        step1_class: 'step-icon',
        step2_class: 'step-icon',
        step3_class: 'step-icon',
        step4_class: 'step-icon',

        isDropdownOpen: false,
        loading_changepassword_submit: false,
        dialogLogoutVisible: false,
        dialogAgreementVisible: false,
        dialogPasswordSettings_smsVisible: false,
        dialogChangePasswordVisible: false,
        dialogChangeAdminVisible: false,      
        loading_passwordSetting_submit: false, // 加载状态
        labelOrgName: '企业名称',
        labelOrgCode: '社会信用代码',
        labelOrgPic: '营业执照',
        
        passwordSettings_smsForm: {
          username: '',
          oldPassword: '',
          newPassword: '',
        },
        HandleOrgTypeChange(val){
          console.log(val)
          switch(val) { 
            case 1://企业
              this.labelOrgName = "企业名称";
              this.labelOrgCode= "社会信用代码";
              this.labelOrgPic = "营业执照";
              break;          
            case 2://个体工商户
              this.labelOrgName = "个体工商户名称";
              this.labelOrgCode= "社会信用代码";
              this.labelOrgPic = "营业执照";
              break;
            case 3://政府与事业单位
              this.labelOrgName = "单位名称";
              this.labelOrgCode= "统一社会信用代码";
              this.labelOrgPic = "《统一社会信用代码证书》或《事业单位法人证书》";
              break;
            case 4://社会组织
              this.labelOrgName = "组织名称";
              this.labelOrgCode= "统一社会信用代码";
              this.labelOrgPic = "登记证书";
              break;    
            case 5://个人开发者
              this.labelOrgName = "开发/创作者名称";
              this.labelOrgCode= "身份证号码";
              this.labelOrgPic = "身份证明文件";
              break;                        
          }
        },
        changePasswordForm: {
          username: '',
          code: '',
          password: '',
        },
        confirmPassword: '',
        loading_sms: false, // 加载状态
        isPhoneValid: false,
        smsError: '',
        countdown: 0,
        isDataLoaded: false,
        previewImage: null,
        open_authentication: false,
        loading_authentication:false,
        authenticationForm:{
          orgType: 1,
          companyName: '',
          nickName:'',
          socialRreditCode: '',   
          contactPerson: '',     
          contactPhone: '',
          code:'',
          aicsUsage: '',
          licenceFile: null
        },
        rules: {
          orgType: [
            { required: true, message: '请选择实体类型', trigger: 'change' }
          ],
          orgName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' }
          ],
        },
        passwordRules: {
          minLength: 6,
          maxLength: 20,
          requireLetter: true,
          requireNumber: true
          // 可扩展：requireSpecialChar: true
        }
      }
    },
    computed: {
      ...mapState('auth', ['tenantInfo', 'userInfo','loginType']),
      isCountingDown() {
        return this.countdown > 0
      },
      // 添加认证状态的即时计算属性
      authenticationStatus() {
        if (!this.tenantInfo) return 'NOT_SUBMITTED'; // 未提交
        return this.tenantInfo.status || 'UNKNOWN';
      }
    },
      watch: {
      // 监听tenantInfo变化，确保流程图状态同步更新
      'tenantInfo.status': {
        immediate: true,
        handler(newStatus) {
          this.updateFlowChartByStatus(newStatus);
        }
      }
    },
    mounted() {
      console.log('🔍 mounted - 开始执行');
      console.log('🔍 mounted - this.userInfo:', this.userInfo);
      console.log('🔍 mounted - this.tenantInfo:', this.tenantInfo);
      console.log('🔍 mounted - localStorage token:', localStorage.getItem('auth_token'));
      console.log('🔍 mounted - localStorage userInfo:', localStorage.getItem('auth_user'));
      
      // 🔴 第一步：先检查用户信息
      let currentUserInfo = this.userInfo;
      
      // 如果 userInfo 为空但有 token，从 localStorage 恢复
      if (!currentUserInfo && localStorage.getItem('auth_token')) {
        const userInfo = JSON.parse(localStorage.getItem('auth_user') || 'null');
        console.log('🔍 mounted - 从 localStorage 恢复 userInfo:', userInfo);
        if (userInfo) {
          this.$store.commit('auth/SET_USER_INFO', {
            username: userInfo.username,
            registerTime: userInfo.registerTime,
            roles: userInfo.roles,
            tenantUserInfo: null,
            employeeUserInfo: null
          });
          // 🔴 重新获取 userInfo
          currentUserInfo = this.$store.state.auth.userInfo;
          console.log('🔍 mounted - 恢复后的 currentUserInfo:', currentUserInfo);

        }
      }
      
      // 🔴 第二步：如果还没有 userInfo，跳转登录页
      if (!currentUserInfo) {
        console.log('❌ mounted - userInfo 为空，跳转登录页');
        this.$router.push('/login');
        return;
      }
      
      // 🔴 现在可以安全访问 userInfo.username
      this.authenticationForm.contactPhone = currentUserInfo.username;
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(currentUserInfo.username);
      
      // 加载套餐设置
      load_version_settings().then(response => {
        console.log("load_version_settings:", response);
        this.version_settings = response.data.data;
        console.log(this.version_settings);
      });

      // 更新流程图状态
      if (this.tenantInfo == null) {
        this.step1_class = 'current-step-icon';
      } else {
        this.step1_class = 'step-over-icon';
        if (this.tenantInfo.status !== 'APPROVED') {
          this.step2_class = 'current-step-icon';
        }
      }

      if (this.tenantInfo != null && this.tenantInfo.logoUrl == null) {
        this.tenantInfo.logoUrl = "https://aics-public.oss-cn-beijing.aliyuncs.com/images/default_avatar.png";
      }

      // 🔴 最后调用 checkAuth
      this.checkAuth();
    },
    methods: {
      ...mapActions('auth', ['logout']), // ogout action
      HandleAuthentication(){
      this.open_authentication = true
      },
    isTokenExpired(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        return payload.exp * 1000 < Date.now()
      } catch (e) {
        return true
      }
    },
    validateForm() {
        if (!this.authenticationForm.companyName) {
          this.$message.error('请输入企业名称')
          return false
        }
        if (!this.authenticationForm.socialCreditCode) {
          this.$message.error('请输入统一社会信用代码')
          return false
        }
        if (!this.authenticationForm.contactPerson) {
          this.$message.error('请输入联系人姓名')
          return false
        }

        if (!this.authenticationForm.code || this.authenticationForm.code.length !== 6) {
          this.$message.error('请输入6位验证码')
          return false
        }

        if (!this.authenticationForm.licenceFile) {
          this.$message.error('请上传营业执照')
          return false
        }
        return true;
    },
  async submitAuthenticationForm() {
    if (!this.validateForm()) return;

    //this.authenticationForm = true;
    let response = null;
    console.log( this.authenticationForm.orgType)
    try {
      const formData = new FormData();
      formData.append('companyName', this.authenticationForm.companyName);
      formData.append('socialCreditCode', this.authenticationForm.socialCreditCode);
      formData.append('contactPerson', this.authenticationForm.contactPerson);
      formData.append('contactPhone', this.authenticationForm.contactPhone);
      formData.append('smsCode', this.authenticationForm.code);
      formData.append('orgType', Number(this.authenticationForm.orgType));
      let websiteCode = process.env.VUE_APP_WEBSITE_CODE || 'SUNRISE-01'
      formData.append('websiteCode', websiteCode);
          formData.append('aicsUsage', this.authenticationForm.aicsUsage);

      // 添加文件
      if (this.authenticationForm.licenceFile) {
        formData.append('licenceFile', this.authenticationForm.licenceFile);
      }

      response = await postAuthentication(formData);
      console.log("authentication response:",response);

      if (response && response.data && response.data.code === 200) { //自定义code
        const message = (response.data && response.data.message) || '实名认证成功';
        this.$message.success(message);
            //this.logout();
            //this.$router.push('/');
            //window.location.reload();
        // 直接更新本地状态，模拟认证已提交状态
        await this.updateLocalTenantStatus();
        this.open_authentication = false;
        this.$confirm('认证申请提交成功！是否刷新页面以确保状态完全同步？', '提交成功', {
              confirmButtonText: '刷新',
              cancelButtonText: '暂不刷新',
              type: 'success'
            }).then(() => {
              window.location.reload();
            }).catch(() => {
              // 用户选择不刷新，保持当前状态
            });          
      } else {
        const errorMsg = (response.data && response.data.message) || '认证失败';
        this.$message.error(errorMsg);
      }
    } catch (error) {
      const errorMsg = (response.data && response.data.message) || '认证失败';
      this.$message.error(errorMsg);
    } finally {
      this.open_authenticationForm = false;
    }
  },
  cancelauthentication(){
    this.open_authentication = false
  },
    // 修改checkAuth方法
async checkAuth() {
  console.log('🔍 checkAuth - this.userInfo:', this.userInfo);
  
  // 🔴 如果 userInfo 为空，尝试从 localStorage 恢复
  if (!this.userInfo) {
    const userInfo = JSON.parse(localStorage.getItem('auth_user') || 'null');
    const token = localStorage.getItem('auth_token');
    
    console.log('🔍 checkAuth - localStorage userInfo:', userInfo);
    console.log('🔍 checkAuth - localStorage token:', token);
    
    if (token && userInfo) {
      // 恢复用户信息到 Vuex
      this.$store.commit('auth/SET_USER_INFO', {
        username: userInfo.username,
        registerTime: userInfo.registerTime,
        roles: userInfo.roles,
        tenantUserInfo: null,
        employeeUserInfo: null
      });
      this.isDataLoaded = true;
      return;
    }
    alert("login") 
    // 没有 token 或 userInfo，跳转登录页
    this.$router.push('/login');
    return;
  }
  
  this.isDataLoaded = true;
},
      validatePhone(phone) {
        let isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
        if (!isPhoneValid) {
          this.$message.error('请输入正确的手机号')
        }
        return isPhoneValid
      },
      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen
      },
      checkCountdown() {
      console.log('checkCountdown');
      const savedTime = localStorage.getItem('smsCountdown');
      console.log(savedTime);
      if (savedTime) {
        const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.countdown = remainingTime;
          this.startCountdown();
        } else {
          localStorage.removeItem('smsCountdown');
        }
      }
      },
      closeDropdown() {
        this.isDropdownOpen = false
      },
      // 密码复杂度校验
    validatePassword(pwd) {
      if (!pwd) {
        this.$message.error('请输入密码');
        return false;
      }

      if (pwd.length < this.passwordRules.minLength) {
        this.$message.error(`密码至少需要${this.passwordRules.minLength}位`);
        return false;
      }

      if (pwd.length > this.passwordRules.maxLength) {
        this.$message.error(`密码最长${this.passwordRules.maxLength}位`);
        return false;
      }

      if (this.passwordRules.requireLetter && !/[a-zA-Z]/.test(pwd)) {
        this.$message.error('密码需包含字母');
        return false;
      }

      if (this.passwordRules.requireNumber && !/\d/.test(pwd)) {
        this.$message.error('密码需包含数字');
        return false;
      }
      return true;
    },
      logoutConfirm() {
        this.dialogLogoutVisible = true
        this.closeDropdown()
      },
      handleLogoutDialogClose() {
        this.dialogLogoutVisible = false
      },
      passwordSetting_sms() {
        this.closeDropdown()
        this.passwordSettings_smsForm.username = this.userInfo.username;
        this.dialogPasswordSettings_smsVisible = true
      },
      ChangePassword(){
        this.closeDropdown()
        this.changePasswordForm.username = this.userInfo.username;
        this.dialogChangePasswordVisible = true
      },
      async handleChangePasswordSubmit() {
        if(this.changePasswordForm.oldPassword===""){
          this.$message.error('原密码不能为空');
          return;
        }
        if(!this.validatePassword(this.changePasswordForm.newPassword)){
          return;
        }
        console.log('changePasswordForm', this.changePasswordForm);
        if (this.changePasswordForm.newPassword !== this.confirmPassword) {
          this.$message.error('两次输入的密码不一致');
          return;
        }
        this.loading_changepassword_submit = true;
        change_password(this.changePasswordForm).then(response => {
          console.log('change_password response', response);
          if (response && response.code === 200) {
            this.$message.success('修改密码成功');
            this.dialogChangePasswordVisible = false; // 关闭对话框
          } else {
            this.$message.error('修改密码失败');
            this.loading_changepassword_submit = false;
          }
        }).catch(error => {
          this.loading_changepassword_submit = false;
          console.error('change_password error', error);
          this.$message.error('修改密码失败'+error);
        });
      },    
        triggerFileInput() {
          this.$refs.licenceFile.click()
        },
      handlePasswordSettings_smsDialogClose() {
        this.dialogPasswordSettings_smsVisible = false
      },
      handleChangePasswordDialogClose() {
        this.dialogChangePasswordVisible = false
      },    
      async logout() {
        try {
          // 调用 Vuex 中的 logout action
          await this.$store.dispatch('auth/logout')
          // 退出成功后跳转到登录页
          this.$router.push('/login')
        } catch (error) {
          console.error('退出登录失败:', error)
          // 即使退出API调用失败，也强制清除本地状态并跳转
          this.$store.commit('auth/CLEAR_AUTH')
          this.$router.push('/login')
        }
      },
      // 上传logo
      isImageFile(file) {
        return file && file.type.match('image.*')
      },
      handleFileUpload(event) {
          const file = event.target.files[0]
          if (file) {
            if (file.size > 5 * 1024 * 1024) {
              this.$message.error('文件大小不能超过5MB')
              event.target.value = ''
              return
            }

            this.authenticationForm.licenceFile = file

            if (this.isImageFile(file)) {
              const reader = new FileReader()
              reader.onload = (e) => {
                this.previewImage = e.target.result
              }
              reader.readAsDataURL(file)
            } else {
              this.previewImage = null
            }
          }      
      },
      removeFile(event) {
        event.preventDefault()
        event.stopPropagation()
        this.authenticationForm.licenceFile = null
        this.previewImage = null
        if (this.$refs.licenceFile) {
          this.$refs.licenceFile.value = ''
        }
      },  
      async sendSMSCode_authentication() {
        let phone = this.authenticationForm.contactPhone;            
        if(phone == null || phone == undefined || phone == ''){
            this.$message.error("请输入联系人手机号");
            return;
          }
          if( !this.validatePhone(phone)){
            this.$message.error("请使用中国大陆有效的手机号");
            return;
          }  
  
          if (this.isCountingDown) return;

        try {
          const response = await send_sms_code(phone)
          console.log(response);
          if (response.data &&response.status===200 && response.data.code === 200) {
            this.startCountdown();
            this.$message.success('验证码已发送');
            this.smsError = '';
          } else {
            this.$message.error((response.data && response.data.message) || '发送验证码失败');
          }
        } catch (error) {

          this.$message.error(error);
        }
      },
      async sendSMSCode_passwordSettings() {
        let phone = this.passwordSettings_smsForm.username;            
        if(phone == null || phone == undefined || phone == ''){
            this.$message.error("请输入用户名（手机号）");
            return;
          }
          if( !this.validatePhone(phone)){
            this.$message.error("请使用中国大陆有效的手机号");
            return;
          }  
  
          if (this.isCountingDown) return;

        try {
          const response = await send_sms_code(phone)
          console.log(response);
          if (response.data &&response.status===200 && response.data.code === 200) {
            this.startCountdown();
            this.$message.success('验证码已发送');
            this.smsError = '';
          } else {
            this.$message.error((response.data && response.data.message) || '发送验证码失败');
          }
        } catch (error) {


          this.$message.error(error);
        }
      },    
      startCountdown() {
        this.countdown = 60;
        localStorage.setItem('smsCountdown', Date.now() + 60000); // 存储过期时间

        if (this.countdownTimer) {
          clearInterval(this.countdownTimer);
        }

        this.countdownTimer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.countdownTimer);
            localStorage.removeItem('smsCountdown');
          }
        }, 1000);
      },
      async handlePasswordSettings_smsSubmit() {
        if (this.passwordSettings_smsForm.code=== ''){
          this.$message.error('请输入验证码');
          return;
        }
        if(!this.validatePassword(this.passwordSettings_smsForm.password)){
          return;
        }
        if (this.confirmPassword==='' || this.confirmPassword===null ||this.confirmPassword== undefined) {
          this.$message.error('两次输入的密码不一致');
          return;
        }
        if (this.passwordSettings_smsForm.password !== this.confirmPassword) {
          this.$message.error('两次输入的密码不一致');
          return;
        }
        this.loading_passwordSetting_submit = true;
        set_password_sms(this.passwordSettings_smsForm).then(response => {
          console.log('set_password_sms response', response);
          if (response && response.code === 200) {
                      this.dialogPasswordSettings_smsVisible = false;
            this.$message.success('设置密码成功');

          }
          else {
            this.loading_passwordSetting_submit = false;          
            this.$message.error('设置密码失败');
            return
          }
        }).catch(error => {
          console.error('set_password_sms error', error);
          this.loading_passwordSetting_submit = false;  
          this.$message.error('设置密码失败'+error);
        });
      },    
      async show_agreement(){
        this.dialogAgreementVisible = true;
      },
      // 新增方法：更新本地租户状态为"已提交"
      async updateLocalTenantStatus() {
        try {
          // 提交到Vuex store更新状态
          this.$store.commit('auth/UPDATE_TENANT_STATUS', {
            status: 'PENDING',
            additionalData: {
              // 可以保存用户提交的一些基本信息，方便显示
              companyName: this.authenticationForm.companyName,
              contactPerson: this.authenticationForm.contactPerson,
              contactPhone: this.authenticationForm.contactPhone,
              orgType: this.authenticationForm.orgType,
              // 可以添加一个临时标记，表示这是本地模拟的状态
              _isTemporaryStatus: true
            }
          });
          
          // 重要：更新组件的响应式数据，确保界面立即更新
          // 因为Vuex的state可能不会立即触发组件更新
          await this.$nextTick();
          
          // 更新流程图状态
          this.step1_class = 'step-over-icon';
          this.step2_class = 'current-step-icon';
          
          this.$message.success('认证申请已提交，状态更新为"待审核"');
          
        } catch (error) {
          console.error('更新本地状态失败:', error);
          // 即使更新失败，用户下次登录也会看到正确状态
        }
      },
      // 根据租户状态更新流程图
      updateFlowChartByStatus(status) {
        if (!status) {
          this.step1_class = 'current-step-icon';
          this.step2_class = 'step-icon';
        } else if (status === 'PENDING') {
          this.step1_class = 'step-over-icon';
          this.step2_class = 'current-step-icon';
        } else if (status === 'APPROVED') {
          this.step1_class = 'step-over-icon';
          this.step2_class = 'step-over-icon';
        }
      }      
    }
}

</script>




<style scoped lang="scss">
//@import '@/styles/public-theme1.scss';
.main-container {
  font-family: 'Alibaba PuHuiTi', sans-serif;
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

/* 导航栏 */
.admin-nav-bar {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 30px;
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  width: 100%;
  z-index: 9999;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  color: #057FDB;
  font-weight: 500;
}

/* 用户操作区 */
.user-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;
}

.welcome-text {
  font-size: 0.8rem;
  color: #666;
}

.user-dropdown {
  position: relative;
  display: inline-block;
}

.avatar-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(5,127,219,0.1);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(5,127,219,0.2);
  }
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(5,127,219,0.3);
}

.username {
  font-size: 0.85rem;
  color: #057FDB;
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-icon-arrow-down {
  font-size: 0.8rem;
  color: #057FDB;
  transition: transform 0.3s;

  &.rotated {
    transform: rotate(180deg);
  }
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 5px);
  min-width: 180px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 10000;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 0.9rem;
  color: #606266;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f5f7fa;
    color: #057FDB;
  }

  i {
    margin-right: 10px;
    font-size: 1rem;
    color: #057FDB;
  }
}

.menu-divider {
  height: 1px;
  background: #ebeef5;
  margin: 4px 0;
}

.menu-item.logout {
  color: #f56c6c;

  i {
    color: #f56c6c;
  }

  &:hover {
    background: #fef0f0;
  }
}

/* 主内容区 */
.admin-main {
  display: flex;
  flex: 1;
}

.sidebar {
  width: 220px;
  background: white;
  border-right: 1px solid #e6e6e6;
  padding: 20px 0;
  box-shadow: 2px 0 5px rgba(0,0,0,0.02);
  transition: all 0.3s;
}

.sidebar-header {
  padding: 0 20px 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
}

.tenant-nickname {
  font-size: 0.8rem;
  color: #666;
  background: #f5f5f5;
  padding: 8px 10px;
  border-radius: 4px;
  word-break: break-all;
  min-width: 10px;
  overflow: hidden;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu li {
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #555;
  transition: all 0.2s;
  position: relative;

  i {
    font-size: 1.1rem;
    color: #888;
  }

  &:hover {
    background: #f0f7ff;
    color: #057FDB;

    i {
      color: #057FDB;
    }
  }

  &.active {
    background: #f0f7ff;
    color: #057FDB;
    border-right: 3px solid #057FDB;

    i {
      color: #057FDB;
    }
  }
}

.content {
  flex: 1;
/*  padding: 30px;*/
  position: relative;
}

/* 流程图样式 */
.flowchart-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 20px 0;
  padding: 20px;
  overflow-x: auto;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .dashboard-charts {
    grid-template-columns: 1fr;
  }
}
.flowchart-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.flowchart {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 1200px;
  padding: 10px 0;
}
.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
}
.step-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.step-icon-with-border {
  width: 40px;
  height: 40px;
  border: 3px solid orange;
  border-radius: 50%;
  background: yellow;
  color: orange;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.current-step-icon {
  width: 40px;
  height: 40px;
  border: 3px solid #057FDB;
  border-radius: 50%;
  background: #fff;
  color: #057FDB;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.current-step-over-icon{
  width: 40px;
  height: 40px;
  border: 3px solid #057FDB;
  border-radius: 50%;
  background: #fff;
  color: #057FDB;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  
}

.step-over-icon{
  width: 40px;
  height: 40px;
  border: 3px solid #bbbbbb;
  border-radius: 50%;
  background: #bbbbbb;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);  
}

.step-over-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #666;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.step-text {
  font-size: 0.8rem;
  color: #555;
  text-align: center;
  max-width: 80px;
  line-height: 1.2;
}
.step-arrow {
  position: absolute;
  right: -15px;
  top: 15px;
  color: #888;
  font-weight: bold;
}
/* 套餐和加油包样式 */
.plans-container, .addons-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin: 20px 0;
  padding: 20px;
}
.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}
.section-description {
  font-size: 10pt;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.2;
}
.plans-table-container, .addons-table-container {
  overflow-x: auto;
}
.plans-table, .addons-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.9rem;
}
.plans-table th, .plans-table td,
.addons-table th, .addons-table td {
  padding: 12px 15px;
  text-align: center;
  border: 1px solid #e0e0e0;
}
.plans-table th, .addons-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}
.plans-table .feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.plans-table .plan-col {
  width: 18.75%;
}
.plans-table .feature-name {
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 800;
}
.plans-table .plan-feature {
  color: #555;
}
.plans-table .price-row .plan-feature {
  font-weight: 600;
  color: #333;
}
.addons-table .addon-feature-col {
  width: 25%;
  text-align: left;
  background-color: #f9f9f9;
  font-weight: 500;
}
.addons-table .addon-col {
  width: 25%;
}

@media (max-width: 1200px) {
  .flowchart {
    min-width: 1000px;
  }

  .step-text {
    font-size: 0.8rem;
    max-width: 70px;
  }
}

@media (max-width: 768px) {
  .flowchart {
    min-width: 800px;
  }

  .step-text {
    font-size: 0.75rem;
    max-width: 60px;
  }
}

#nickName {
    flex: 1;             // input 占据剩余空间
    padding: 12px 15px;
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    width: 65%;
    background: rgba(240, 244, 249, 0.5);
    margin-left: 20px;

    &:focus {
      border-color: #057FDB;
      box-shadow: 0 0 0 3px rgba(#057FDB, 0.2);
    }
  }

  .upload-container {
    margin-top: 10px;
    width: 100%;
  }

  .file-input {
    display: none;
  }
  .required-asterisk {
    color: #ff4d4f; /* 红色 */
    margin-right: 4px;
  }
  .upload-box {
    display: block;
    width: 100%;
    height: 120px;
    border: 2px dashed $gray-border;
    border-radius: 8px;
    background-color: rgba(240, 244, 249, 0.5);
    cursor: pointer;
    transition: all 0.3s;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #057FDB;
      background-color: rgba(#057FDB, 0.05);
    }
  }
  .upload-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
  }

  .plus-icon {
    font-size: 2rem;
    font-weight: lighter;
    margin-bottom: 8px;
    color: #057FDB;
  }

  .upload-text {
    font-size: 0.9rem;
  }

  .file-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 20px;
    position: relative;
  }

  .thumbnail {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }


.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  
  &:hover {
    background: #ff7875;
  }
}
  /* 微动点状背景的额外样式 */
.particle-point {
  position: absolute;
  background: #057FDB;
  border-radius: 50%;
  animation: float 6s infinite ease-in-out;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-8px) scale(1.05);
    opacity: 0.6;
  }
}

canvas[data-generated] {
  position: absolute;
  top: 0;
  left: 0;
}


.form-group {
  display: flex;          // 使用 flex 布局
  align-items: center;   // 垂直居中
  margin-bottom: 10px;   // 保持原有的底部间距
  margin-left: 0;
  padding-left: 0;

  label {
    flex: 0 0 80px;     // 固定 label 宽度
    margin-bottom: 0;    // 移除原来的底部 margin
    padding-right: 15px; // label 和 input 之间的间距
    text-align: right;   // 文字右对齐（可选）
    font-weight: 500;
    color: #474747;
  }

  input {
    flex: 1;             // input 占据剩余空间
    padding: 12px 15px;
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    background: rgba(240, 244, 249, 0.5);

    &:focus {
      border-color: #00b4ff;
      box-shadow: 0 0 0 3px rgba(#00b4ff, 0.2);
    }
  }
}

#sms-code {
  width: 80px;
}
.sms-group {
  display: flex;
  align-items: left;
  /*gap: 10px;*/

  input {
    display: inline-flexbox;
    min-width: 60px;
    max-width: 100px;
  }

  .sms-btn {
    background: #00b4ff;
    color: white;
    border: none;
    padding: 0 15px;
    height: 44px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken(#00b4ff, 10%);
    }
  }
}
/* 修复下拉框层级问题 */
::v-deep .custom-select-popper {
  z-index: 10001 !important;
}

/* 修复 Element UI 图标显示问题 */
::v-deep .el-select .el-input .el-select__caret {
  font-family: element-icons !important;
  color: #c0c4cc;
}

::v-deep .el-select .el-input .el-select__caret:before {
  content: "\e6df";
}

::v-deep .el-select .el-input.is-focus .el-select__caret {
  color: #409EFF;
}

.sms-group {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
    min-width: 0;
  }

  .sms-btn {
    background:  #409EFF;
    color: white;
    border: none;
    padding: 0 5px;
    height: 34px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken( #409EFF, 10%);
    }
  }
}
.form-note {
  font-size: 0.75rem;
  margin: 5px 5px 5px 120px;
  width: 350px;
  color: #888;  
}
.upload-area {
  width: 100%;
  height: 120px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  background-color: rgba(240, 244, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    border-color: #057FDB;
    background-color: rgba(5, 127, 219, 0.05);
  }
}
.preview-area {
  position: relative;
  width: 100%;
  height: 120px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: white;
}
/* 禁用文本域缩放 */
.custom-textarea {
  resize: none;
  font-size: 14px;
}
.status-text{
  font-family: 'Courier New', Courier, monospace;
  font-size: 9pt;
  font-weight: 300;
}
</style>